import { IListObjectStore } from "../../_common/type";
import { IJobHOCState } from "../../_core/job/types";
import { EMARPOLDocuments } from "../marpol/@types";
import { TORB3GroupA } from "./groups/group-a";
import { TORB3GroupB } from "./groups/group-b";
import { TORB3GroupC } from "./groups/group-c";
import { TORB3GroupD } from "./groups/group-d";
import { TORB3GroupE } from "./groups/group-e";
import { TORB3GroupF } from "./groups/group-f";

// Enums

export enum EORB3OperationState {
	RECORD = "RECORD",
	PREVIEW = "PREVIEW",
}

export enum EORB3RecordState {
	APPROVED = "APPROVED",
	STRIKED_OFF = "STRIKED-OFF",
	SUBMITTED = "SUBMITTED",
	IDLE = "IDLE",
	EDIT = "EDIT",
	VERIFIED = "VERIFIED",
}

export enum EORB3RecordCode {
	ORB3_A1 = "ORB3-A1",
	ORB3_A2 = "ORB3-A2",
	ORB3_A3 = "ORB3-A3",
	ORB3_A4 = "ORB3-A4",
	ORB3_A5 = "ORB3-A5",

	ORB3_B1 = "ORB3-B1",
	ORB3_B2 = "ORB3-B2",
	ORB3_B3 = "ORB3-B3",

	ORB3_C3 = "ORB3-C3",
	ORB3_C4_1 = "ORB3-C4-1",
	ORB3_C4_2 = "ORB3-C4-2",
	ORB3_C4_3 = "ORB3-C4-3",

	ORB3_D5 = "ORB3-D5",

	ORB3_E = "ORB3-E",

	ORB3_F1 = "ORB3-F1",
	ORB3_F2 = "ORB3-F2",
}

export enum EORB3EditMode {
	GENERAL = "GENERAL",
	APPROVED_EDIT = "APPROVED_EDIT",
}

// Common field and metadata types

export type TORB3RecordUser = {
	name: string;
	designation: string;
	staffId: string;
	date: string;
};

export type TORB3CommonFields = {
	selectedDate: string;
	remarks: string;
};

export type TORB3CommonData = {
	id: string;
	_rev: string;
	marpolType: EMARPOLDocuments.ORB3;
	state: EORB3RecordState;
	timeZone?: string;
	submittedBy?: TORB3RecordUser;
	approvedBy?: TORB3RecordUser;
	verifiedBy?: TORB3RecordUser;
	strikedBy?: TORB3RecordUser;
	strikeOffReason?: string;
	editVersions?: TORB3Record[];
	dateOfApprovedRecordEdit?: string;
	_attachments?: object;
};

// Union of all ORB-3 records

export type TORB3Record =
	| TORB3GroupA
	| TORB3GroupB
	| TORB3GroupC
	| TORB3GroupD
	| TORB3GroupE
	| TORB3GroupF;

// Backend / alert / operation types

export type TORB3OperationAlert = {
	id: string;
	type: "WARNING" | "ERROR" | "INFO" | "REQUIRED_FIELD";
	title: string;
	subtitle: string;
	message: string;
	listOfItems?: {
		title: string;
		subtitle?: string;
		message?: string;
		link?: string;
	}[];
	action?: { title: string; link: string };
};

export type TORB3BackendRecord = TORB3Record & {
	submittedBy: TORB3RecordUser;
	approvedBy?: TORB3RecordUser;
	verifiedBy?: TORB3RecordUser;
	strikedBy?: TORB3RecordUser;
	editedBy?: TORB3RecordUser;
	isEditWarningVisible?: boolean;
};

export type TORB3CurrentOperation = {
	recordCode: EORB3RecordCode;
	operationState: EORB3OperationState;
	formData: TORB3Record;
	validationAlerts: IListObjectStore<TORB3OperationAlert>;
	editMode?: EORB3EditMode;
};

export type TORB3HistoryFilters = {
	vesselId?: string;
	startDate: any;
	endDate: any;
	shownRecords: "ALL" | "ALL-PENDING";
	state?: EORB3RecordState | string;
	sortOrder?: "asc" | "desc";
};

// Store shape

export interface IORB3Store extends IJobHOCState {
	records: IListObjectStore<TORB3BackendRecord>;
	currentOperation?: TORB3CurrentOperation;
	filter: TORB3HistoryFilters;
}
